import useSessionStorage from "../../../hooks/useSessionStorage";
import requestUtil from "../../../helpers/requestUtil";
import useConfiguration from "../../../hooks/useConfiguration";
import './index.css';
import {useEffect, useState} from "react";
export default (props) => {
    const storage = useSessionStorage();
    const user = storage.getItem('login');
    const config = useConfiguration();
    const [messages, setMessages] = useState([]);
    useEffect(() => {
        setTimeout(() => window.setUpChatWindow(), 2000);
    })
    useEffect(() => {
        if(props.jobId && config.baseUrl){
            requestUtil(`${config.baseUrl}/Messages/GetMessageListtoGrid`, 'POST', {
                jobUniqueId: props.jobId,
                employerUniqueId: user.employerUniqueId
            }).then((result) => {
                setMessages(result.candidateMessages);
            });
        }
    }, [props.jobId, config])
    return (
       <div className="col-sm-12 col-md-12 col-lg-12 col-xl-5">
            <div className="card">
                <div className="main-content-app pt-0">
                    <div className="main-content-body main-content-body-chat h-100">
                        <div className="main-chat-header pt-3 d-block d-sm-flex">
                            <div className="main-img-user online"><img alt="avatar" src="../assets/images/users/1.jpg" />
                            </div>
                            <div className="main-chat-msg-name mt-2">
                                <h6>{user.fullName}</h6>
                                <span className="dot-label bg-success"></span><small className="me-3">online</small>
                            </div>
                            <button className={"btn btn-secondary close-button"} onClick={() => {
                                props.closeChatWindow()
                            }}>X</button>
                        </div>
                        <div className="main-chat-body flex-2" id="ChatBody">
                            <div className="content-inner">
                                <label className="main-chat-time"><span>2 days ago</span></label>
                                <div className="media flex-row-reverse chat-right">
                                    <div className="main-img-user online"><img alt="avatar"
                                                                               src="../assets/images/users/21.jpg" />
                                    </div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Nulla consequat massa quis enim. Donec pede justo, fringilla vel...
                                        </div>
                                        <div className="main-msg-wrapper">
                                            rhoncus ut, imperdiet a, venenatis vitae, justo...
                                        </div>
                                        <div>
                                            <span>9:48 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="media chat-left">
                                    <div className="main-img-user online"><img alt="avatar"
                                                                               src="../assets/images/users/1.jpg" /></div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                            ligula eget dolor.
                                        </div>
                                        <div>
                                            <span>9:32 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="media flex-row-reverse chat-right">
                                    <div className="main-img-user online"><img alt="avatar"
                                                                               src="../assets/images/users/21.jpg" />
                                    </div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                            ligula eget dolor
                                        </div>
                                        <div className="main-msg-wrapper">
                                                                <span className="text-dark"><span><i
                                                                    className="fa fa-image fs-14 text-muted pe-2"></i></span><span
                                                                    className="fs-14 mt-1"> Image_attachment.jpg </span>
                                                                <i className="fe fe-download mt-3 text-muted ps-2"></i>
                                                                </span>
                                        </div>
                                        <div>
                                            <span>11:22 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <label className="main-chat-time"><span>Yesterday</span></label>
                                <div className="media chat-left">
                                    <div className="main-img-user online"><img alt="avatar"
                                                                               src="../assets/images/users/1.jpg" /></div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                            ligula eget dolor.
                                        </div>
                                        <div>
                                            <span>9:32 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="media flex-row-reverse chat-right">
                                    <div className="main-img-user online"><img alt="avatar"
                                                                               src="../assets/images/users/21.jpg" />
                                    </div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla
                                            consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec. In
                                            enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.
                                        </div>
                                        <div className="main-msg-wrapper">
                                            Nullam dictum felis eu pede mollis pretium
                                        </div>
                                        <div>
                                            <span>9:48 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <label className="main-chat-time"><span>Today</span></label>
                                <div className="media chat-left">
                                    <div className="main-img-user online"><img alt="avatar" src="../assets/images/users/1.jpg"/></div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Maecenas tempus, tellus eget condimentum rhoncus
                                        </div>
                                        <div className="main-msg-wrapper">
                                            <img alt="avatar" className="w-10 h-10" src="../assets/images/media/3.jpg" />
                                                <img alt="avatar" className="w-10 h-10"
                                                     src="../assets/images/media/4.jpg" />
                                                    <img alt="avatar" className="w-10 h-10"
                                                         src="../assets/images/media/5.jpg"/>
                                        </div>
                                        <div>
                                            <span>10:12 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="media flex-row-reverse chat-right">
                                    <div className="main-img-user online"><img alt="avatar" src="../assets/images/users/21.jpg"/>
                                    </div>
                                    <div className="media-body">
                                        <div className="main-msg-wrapper">
                                            Maecenas tempus, tellus eget condimentum rhoncus
                                        </div>
                                        <div className="main-msg-wrapper">
                                            Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas
                                            nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis
                                            faucibus.
                                        </div>
                                        <div>
                                            <span>09:40 am</span> <a href=""><i
                                            className="icon ion-android-more-horizontal"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main-chat-footer">
                            <input className="form-control" placeholder="Type your message here..." type="text" />
                                <a className="nav-link" data-bs-toggle="tooltip" href="" title="Attach a File"><i
                                    className="fe fe-paperclip"></i></a>
                                <button type="button" className="btn btn-icon  btn-primary brround"><i
                                    className="fa fa-paper-plane-o"></i></button>
                                <nav className="nav">
                                </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
